import React from 'react';
import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSelector } from 'react-redux';
import Modifier from 'features/common/Modifier';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import { useRef, useState, useEffect } from 'react';
import {
  selectCurrentFolder,
  selectTruncateLongFolderName,
  selectUploadDrawerFolder,
} from 'common/selectors';
import { faArrowCircleUp } from '@fortawesome/free-solid-svg-icons';

export default ({ folder, icon, buttonActions }: any) => {
  const titleRef = useRef<any>();
  const [showTooltip, setShowTooltip] = useState(false);
  const [folderSelected, setFolderSelected] = useState(false);
  const truncateLongFolderName = useSelector(selectTruncateLongFolderName);
  const currentFolder = useSelector(selectCurrentFolder) as any;

  useEffect(() => {
    setShowTooltip(
      titleRef.current !== null &&
        !folderSelected &&
        titleRef.current?.clientHeight < titleRef.current?.scrollHeight,
    );
    if (folderSelected && currentFolder.code !== folder.code) setFolderSelected(false);
    else if (!folderSelected && currentFolder.code === folder.code) setFolderSelected(true);
  }, [folderSelected, setShowTooltip, currentFolder, folder]);

  const folderSelectedForUpload = useSelector(selectUploadDrawerFolder);
  const isUploadable =
    folder?.type === 'trialbook' ||
    folder?.type === 'team-bundle' ||
    folder?.type === 'private-bundle';
  return (
    <>
      <div style={{ flexGrow: 1 }}>
        {icon && <>{icon.type === 'muiIcon' ? icon.component : <FontAwesomeIcon icon={icon} />}</>}
        {folderSelectedForUpload?.id === folder?.id && isUploadable ? (
          <FontAwesomeIcon icon={faArrowCircleUp} />
        ) : null}
        <OverlayTrigger
          placement="top"
          delay={{ show: 100, hide: 100 }}
          trigger={showTooltip ? ['hover', 'focus', 'click'] : []}
          overlay={
            <Popover id="folderName" style={{ pointerEvents: 'none' }}>
              <Popover.Content>{folder.name}</Popover.Content>
            </Popover>
          }
        >
          <div
            ref={titleRef}
            className={classnames({
              longFolderName: truncateLongFolderName && !folderSelected,
            })}
          >
            {folder.name}
          </div>
        </OverlayTrigger>
      </div>
      {buttonActions && <Modifier {...{ buttonActions: buttonActions({ folder }) }} />}
    </>
  );
};
